import * as React from 'react';
import { SpinLoader } from 'app/components/spin-loader';
import { useActionCreators, useSelectors } from './hooks';
import { useEffect } from 'react';

/**
 * Runs the action creator to create a new entity then redirects to the draft
 *
 */
export const CaseCreator = (api: any = undefined) => ({ params, router }: { params: any, router: any }) => {
  const {
    createCase
  } = useActionCreators(api);

  const {
    caseTypeId,
    caseContextId,
    parentConnection
  } = useSelectors(params, router);

  useEffect(() => {
    createCase(caseTypeId, caseContextId, parentConnection);
  }, [caseTypeId, caseContextId, parentConnection]);

  return <SpinLoader />;
};
